<template>
    <div style="margin: 16px;">
        <p>在您使用本软件之前，请您务必仔细阅读并透彻理解本声明。您可以选择不使用本软件，但如果您使用本软件，则视为您完全接受本声明的全部内容。</p>
        <p>1、请在汽车行驶前或停靠时操作本软件，切勿在行驶过程中操作，否则由此造成的安全事故应由您自行承担责任。</p>
        <p>2、请您在注册后使用本软件，并在需要使用某些功能时开启对本软件的具体授权。我司采集的用户信息将在匿名化处理的基础上进行分析研究，用于产品改善和新功能开发。</p>
        <p>3、本软件在使用过程中可能会产生网络流量费用，例如进行在线定位、路线规划、导航、实时路况、网络音乐、网络FM、车载对讲等，该费用由您互联的手机的相应网络服务提供商收取。</p>
        <p>4、本软件包含车机端互联软件，其适用于指定OEM车载终端或授权服务商，如果在其他的终端系统上使用该软件出现任何问题，或由于使用者使用手机端任意第三方软件进行投屏反控导致出现的任何问题，本公司不承担任何责任。</p>
        <p>5、本软件提供的任何导航功能及音乐播放、电话服务、车载对讲功能仅供您参考使用，请不要以此作为您行驶或出行的唯一依据，请您以实际的交通和道路状况为准。</p>
        <p>6、请根据实际交通状况选择交通路线，地图导航仅供参考，任何违反交通法规和其他法律规定的行为，将由您自行承担责任。</p>
        <p>7、请您不要允许他人使用您装载的本软件，否则视为您已将本声明内容全部告知他人且为他人完全接受。</p>
        <p>8、未成年人应在法定监护人的陪同下使用本软件。未成年人不得单独使用本软件。</p>
    </div>
</template>
<script>
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

export default {
    mounted() {
        // var lang = this.$route.query.lang;
        // if(lang != null){
        //     const store = useStore();
        //     const i18n = useI18n();
        //     i18n.locale.value = lang;
        //     store.commit("setLanguage", lang);
        // }
        document.title = this.$t('msg.disclaimer')
    }
}
</script>
<style>
p {
    text-indent: 2em;
}
</style>